export const PAYMENT_TYPES = {
    STRIPE: 'stripe',
    SOA: 'statementOfAccounts',
} as const